const config = {
  docsearchApiKey: process.env.GATSBY_DOCSEARCH_API_KEY,
  docsearchIndex: process.env.GATSBY_DOCSEARCH_INDEX,
  docsearchAppId: process.env.GATSBY_DOCSEARCH_APP_ID,
};

export default config;
